export const GET_SURVEY = 'GET_SURVEY';
export const GET_SURVEY_FAIL = 'GET_SURVEY_FAIL';
export const UPDATE_SURVEY = 'UPDATE_SURVEY';
export const LOG_OUT = 'LOG_OUT';
export const AUTO_SAVE_SUCCESS = 'AUTO_SAVE_SUCCESS';
export const AUTO_SAVE_FAIL = 'AUTO_SAVE_FAIL';
export const GET_QUESTIONS_DROPPED = 'GET_QUESTIONS_DROPPED';
export const CHECK_TERM_AND_POLICY = 'CHECK_TERM_AND_POLICY';
export const START_SURVEY = 'START_SURVEY';
export const START_TIMER = 'START_TIMER';
export const GO_TO_PAGE = 'GO_TO_PAGE';
export const GET_QUESTION_FOR_A_PAGE = 'GET_QUESTION_FOR_A_PAGE';
export const DOUBLE_CLICK_STATEMENT = 'DOUBLE_CLICK_STATEMENT';
export const RESPONDENT_NAME = 'RESPONDENT_NAME';
export const ENGAGEMENT_SURVEY_TOKEN = 'ENGAGEMENT_SURVEY_TOKEN';
export const GET_SURVEY_RESULT = 'GET_SURVEY_RESULT';
export const GET_SHARE_LINK = 'GET_SHARE_LINK';
export const GET_SURVEY_OPTIONS = 'GET_SURVEY_OPTIONS';
export const GET_SURVEY_OPTIONS_FAIL = 'GET_SURVEY_OPTIONS_FAIL';
export const GET_SURVEY_OPTIONS_SUCCESS = 'GET_SURVEY_OPTIONS_SUCCESS';
export const GET_SURVEY_AGES = 'GET_SURVEY_AGES';
export const GET_SURVEY_AGES_SUCCESS = 'GET_SURVEY_AGES_SUCCESS';
export const GET_SURVEY_AGES_FAILURE = 'GET_SURVEY_AGES_FAILURE';
export const GET_SURVEY_GENDERS = 'GET_SURVEY_GENDERS';
export const GET_SURVEY_GENDERS_SUCCESS = 'GET_SURVEY_GENDERS_SUCCESS';
export const GET_SURVEY_GENDERS_FAILURE = 'GET_SURVEY_GENDERS_FAILURE';
export const UPDATE_RESPONDENT_DEMOGRAPHICS = 'UPDATE_RESPONDENT_DEMOGRAPHICS';
export const UPDATE_RESPONDENT_DEMOGRAPHICS_SUCCESS = 'UPDATE_RESPONDENT_DEMOGRAPHICS_SUCCESS';
export const UPDATE_RESPONDENT_DEMOGRAPHICS_FAILURE = 'UPDATE_RESPONDENT_DEMOGRAPHICS_FAILURE';
export const GET_LOGO_URL = 'GET_LOGO_URL';
export const GET_LOGO_URL_SUCCESS = 'GET_LOGO_URL_SUCCESS';
export const GET_LOGO_URL_FAILURE = 'GET_LOGO_URL_FAILURE';
export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS';
export const CHANGE_LANGUAGE_FAILED = 'CHANGE_LANGUAGE_FAILED';
export const FETCH_LOCALE_FILES_SUCCESS = 'FETCH_LOCALE_FILES_SUCCESS';
export const FETCH_LOCALE_FILES_FAILED = 'FETCH_LOCALE_FILES_FAILED';
export const FETCH_LOCALE_FILES = 'FETCH_LOCALE_FILES';
export const END_TIMER = 'END_TIMER';
export const CLEAR_TIMER = 'CLEAR_TIMER';
